// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, recordOf, maybe } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementContentBlocksUpdateTagsResult = objectOf({
  info: string,
  undo_identifier: maybe(number),
  undo_data: objectOf({
    desired_state: recordOf({
      key: string,
      value: arrayOf(string),
    }),
  }),
  all_tags: arrayOf(string),
  used_tags: arrayOf(string),
});
